export default __webpack_public_path__ + "static/media/mkr.ae823db1.png";